/* @flow */
import * as React from 'react';

import Button from 'components/Button.jsx';

import type { Props as ButtonProps } from 'components/Button.jsx';

export function getButtonCellGenerator(input: {
  fieldForAction: string,
  onClickAction: any => void,
  buttonLabel: React.Node,
  buttonProps: $Shape<ButtonProps>,
}) {
  return (data: Object) => {
    if (!input.buttonLabel) {
      return null;
    }

    return (
      <Button
        {...input.buttonProps}
        onClick={() => input.onClickAction(data[input.fieldForAction])}>
        {input.buttonLabel}
      </Button>
    );
  };
}
